// extracted by mini-css-extract-plugin
module.exports = {"container":"_89b4965636--container--FXbKM","phone":"_89b4965636--phone--AgIIL","footer":"_89b4965636--footer--ur2Oi","company":"_89b4965636--company--pwkxk"};